import React from 'react';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import SyllablesWrapper from "./exercises/syllables/SyllablesWrapper";
import NonWordsWrapper from "./exercises/nonWords/NonWordsWrapper";
import SentencesWrapper from "./exercises/sentences/SentencesWrapper";
import HidingGame from "./exercises/hidingGame/HidingGame";
import {AppProvider} from "./contexts/AppContext";
import Home from "./pages/Home";
import ExePage from "./pages/ExePage";
import Intro from "./pages/Intro";
import Login from "./pages/Login";
import Congratulations from "./pages/Congratulations";
import Reward from "./pages/Reward";
import NonWordsTutorial from "./exercises/nonWords/NonWordsTutorial";
import SentencesTutorial from "./exercises/sentences/SentencesTutorial";
import SyllablesTutorial from "./exercises/syllables/SyllablesTutorial";
import SyllablesTest from "./exercises/syllables/SyllablesTest";
import NonWordsTest from "./exercises/nonWords/NonWordsTest";
import SentencesTest from "./exercises/sentences/SentencesTest";
import TherapistLogin from "./pages/TherapistLogin";
import TherapistDashboard from "./pages/TherapistDashboard";

const exerciseWrappers = {
    syllables: SyllablesWrapper,
    nonWords: NonWordsWrapper,
    sentences: SentencesWrapper,
    hidingGame: HidingGame
};

const tutorials = {
    syllables: SyllablesTutorial,
    nonWords: NonWordsTutorial,
    sentences: SentencesTutorial
};

const tests = {
    syllables: SyllablesTest,
    nonWords: NonWordsTest,
    sentences: SentencesTest
};

function MainExerciseWrapper() {
    const { exerciseId } = useParams();
    const Component = exerciseWrappers[exerciseId];
    return Component ? <Component /> : <div>Unknown exercise</div>;
}

function Tutorial() {
    const { exerciseId } = useParams();
    const Component = tutorials[exerciseId];
    return Component ? <Component /> : <div>Unknown exercise</div>;
}

function Test() {
    const { exerciseId } = useParams();
    const Component = tests[exerciseId];
    return Component ? <Component /> : <div>Unknown exercise</div>;
}

function ExercisePhaseWrapper() {
    const { exerciseId, phase, level } = useParams();

    const phaseComponents = {
        main: <MainExerciseWrapper />,
        intro: <Intro exerciseId={exerciseId}/>,
        tutorial: <Tutorial />,
        test: <Test />,
        congratulations: <Congratulations exerciseId={exerciseId} />,
        reward: <Reward exerciseId={exerciseId} level={level} />
    };

    return phaseComponents[phase] || <div>Unknown phase</div>;
}

function App() {
    return (
        <AppProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<Home />} />

                    {/* Fasi parametrizzate per ciascun esercizio */}
                    <Route path="/exercise/:exerciseId/:phase/:level?" element={<ExercisePhaseWrapper />} />

                    <Route path="/pages/exePage" element={<ExePage />} />
                    <Route path="/pages/general/intro" element={<Intro />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/therapist/login" element={<TherapistLogin />} />
                    <Route path="/therapist/dashboard" element={<TherapistDashboard />} />
                </Routes>
            </Router>
        </AppProvider>
    );
}

export default App;
